// @ vendor
const React = require('react');

// @components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;

// @utilities
const { recordProcess } = require('utilities/tagging');

//@constants
const {
    PROC_DELETE_SHIPPING_ADDRESS,
    PROC_END,
} = require('utilities/tagging');

class MyProfileRemoveShippingAddressSuccess extends React.Component {

    componentDidMount() {
        recordProcess(PROC_DELETE_SHIPPING_ADDRESS, PROC_END);
    }

    render() {
        const goBackButton = {
            label: (
                <FormattedText
                    value="profileEditShippingAddress-profileEditShippingAddress_successBackButtonText"
                />
            ),
            url: `/myprofile/edit`
        };
        const successMessage = formatText('profileRemoveShippingAddress-profileRemoveShippingAddress_removeSuccessTitle');

        return (
            <WizardSuccess
                mainButton={goBackButton}
                successMessage={successMessage}
            >
                <FormattedText
                    value="profileRemoveShippingAddress-profileRemoveShippingAddress_removeSuccessMessage"
                />
            </WizardSuccess>
        );
    }
}

module.exports = MyProfileRemoveShippingAddressSuccess;
